import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const chipContent: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};
